import React, { useContext, useEffect, useState, useRef } from 'react';
import { SpaceBetween, Grid, Flashbar } from '@amzn/awsui-components-react-v3';
import '../../styles/spotcp.css';
import { EmptyContent } from './emptyContent';
import { SpotcpHeader } from './header';
import { Trend } from './trend';
import { HistogramShipments } from './histogram-shipments';
import { HistogramComponents } from './histogram-components';
import { AsinAnalysis } from './asin-analysis';
import { StateContext } from './context/spotcp-context';
import { ReportTable } from './custom/report-table';
import { SpotcpSummaryInfo, SpotcpAsinHistroyFilterInfo, SpotcpPCogsSourceFilterInfo } from './info';
import { summaryColumnDefinitions, advancedFilterColumnDefinitions } from './elements';

const SpotcpContent = (props) => {
  const {
    requestSubmitted,
    showAsinAnalysis,
    flashbarItem,
    summaryDataLA,
    summaryDataFA,
    asinHistoryFA,
    asinHistoryLA,
    pcogsSourceFA,
    pcogsSourceLA,
  } = useContext(StateContext);

  const [flashbarItems, setFlashbarItems] = useState([]);
  const asinAnalysisRef = useRef(null)

  useEffect(() => {
    if (flashbarItem) {
      const dismissId = flashbarItem.id;
      setFlashbarItems(
        flashbarItems.concat({
          ...flashbarItem,
          onDismiss: () => setFlashbarItems(flashbarItems.filter((item) => item.id !== `${dismissId}`)),
        })
      );
    }
  }, [flashbarItem]);

  return (
    <React.Fragment>
      <div className="spotcp-sticky-flashbar">
        <Flashbar items={flashbarItems} />
      </div>
      <div className="awsui-util-p-s">
        <SpaceBetween size="m">
          <SpotcpHeader updateTools={props.updateTools} />
          <Grid
            gridDefinition={[
              { colspan: { l: '12', m: '12', default: '12' } },
              { colspan: { l: '12', m: '12', default: '12' } },
              { colspan: { l: '6', m: '6', default: '12' } },
              { colspan: { l: '6', m: '6', default: '12' } },
              { colspan: { l: '6', m: '6', default: '12' } },
              { colspan: { l: '6', m: '6', default: '12' } },
              { colspan: { l: '12', m: '12', default: '12' } },
            ]}
          >
            {requestSubmitted ? (
              <React.Fragment>
                <ReportTable
                  columnDefinitions={summaryColumnDefinitions}
                  faData={summaryDataFA}
                  laData={summaryDataLA}
                  updateTools={props.updateTools}
                  title="Summary"
                  description="SPOT CP, HCP Unit value and Accuracy %"
                  infoComponent={<SpotcpSummaryInfo />}
                />
                <Trend />
                <ReportTable
                  columnDefinitions={advancedFilterColumnDefinitions}
                  faData={asinHistoryFA}
                  laData={asinHistoryLA}
                  updateTools={props.updateTools}
                  title="AUX component Source"
                  description="Total Accuracy, Net CP Net Variance and Weight"
                  infoComponent={<SpotcpAsinHistroyFilterInfo />}
                />
                <ReportTable
                  columnDefinitions={advancedFilterColumnDefinitions}
                  faData={pcogsSourceFA}
                  laData={pcogsSourceLA}
                  updateTools={props.updateTools}
                  title="Product Cogs Source"
                  description="Product Cogs Accuracy, Product Cogs Net Variance and Weight"
                  infoComponent={<SpotcpPCogsSourceFilterInfo />}
                />
                <HistogramShipments updateTools={props.updateTools} asinAnalysisRef={asinAnalysisRef}/>
                <HistogramComponents updateTools={props.updateTools} asinAnalysisRef={asinAnalysisRef}/>
                {showAsinAnalysis && <div ref={asinAnalysisRef}><AsinAnalysis updateTools={props.updateTools} /></div>} 
              </React.Fragment>
            ) : (
              <EmptyContent />
            )}
          </Grid>
        </SpaceBetween>
      </div>
    </React.Fragment>
  );
};

export default SpotcpContent;



// WEBPACK FOOTER //
// ./src/components/spotcp/contents.jsx